// import React, { useEffect } from "react";

// const OgMetaTitles = ({ title, type, url, image }) => {
//   console.log("OgMetaTitles component rendered with title:", title, "type:", type, "url:", url, "image:", image);
  
//   useEffect(() => {
//     // Function to update or create a meta tag
//     const setMetaTag = (property, content) => {
//       let tag = document.querySelector(`meta[property='${property}']`);
//       if (tag) {
//         tag.setAttribute("content", content);
//       } else {
//         tag = document.createElement("meta");
//         tag.setAttribute("property", property);
//         tag.setAttribute("content", content);
//         document.head.appendChild(tag);
//       }
//     };

//     // Set the Open Graph meta tags
//     setMetaTag("og:title", title);
//     setMetaTag("og:type", type);
//     setMetaTag("og:url", url);
//     setMetaTag(
//       "og:image",
//       image
//         ? image
//         : "https://www.mountainmysteries.com/static/media/Mountain-mystries-logo.54b65b51cce41f636b77.png"
//     );

//     // Optional cleanup function to remove tags (if necessary)
//     return () => {
//       document.querySelectorAll("meta[property^='og:']").forEach((tag) => {
//         document.head.removeChild(tag);
//       });
//     };
//   }, [title, type, url, image]);

//   return null; // This component doesn't render anything visible
// };

// export default OgMetaTitles;


import React, { useEffect } from "react";

const DEFAULT_IMAGE = "https://www.mountainmysteries.com/static/media/Mountain-mystries-logo.54b65b51cce41f636b77.png";

const OgMetaTitles = ({ title, type, url, image, description }) => {
  useEffect(() => {
    const setMetaTag = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (tag) {
        tag.setAttribute("content", content);
      } else {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        tag.setAttribute("content", content);
        tag.setAttribute("data-react-og", "true");
        document.head.appendChild(tag);
      }
    };

    setMetaTag("og:title", title);
    // setMetaTag("og:type", type);
    setMetaTag("og:description", description);
    setMetaTag("og:url", url);
    setMetaTag("og:image", image || DEFAULT_IMAGE);

    return () => {
      document.querySelectorAll("meta[data-react-og='true']").forEach((tag) => {
        document.head.removeChild(tag);
      });
    };
  }, [title, type, url, image, description]);

  return null;
};

export default OgMetaTitles;
